import React from 'react'
import Image from '@/components/Image'

function ImageOverlay({ children, imageProps }) {
  return (
    <div className="relative block overflow-hidden rounded-xl">
      <Image {...imageProps} />
      <div
        className="absolute top-0 right-0 bottom-0 left-0
        flex items-center justify-center text-center p-8
        bg-gray-1100 bg-opacity-25 text-white"
      >
        {children}
      </div>
    </div>
  )
}

export default ImageOverlay
